import store from "@/store";

export const checkPermission = (value) => {
  const roles = store.state.user.btnCodes || [];
  let hasPermission = false;
  if (typeof value === "string") {
    value.length && (hasPermission = roles.includes(value));
  }
  if (Array.isArray(value)) {
    for (let i = 0; i < value.length; i++) {
      if (roles.includes(value[i])) hasPermission = true;
    }
  }
  return hasPermission;
};
